import { Box, colors, Divider, Skeleton, Typography } from "@mui/material";

export default function PdpNoSsrSidebarSkeletons() {
    return (
        <Box sx={{ mt: 1 }}>
            <Typography sx={{ fontSize: 15, color: colors.grey[700], fontWeight: 400 }}>انتخاب رنگ</Typography>

            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Skeleton variant="rounded" height={52} width={52} sx={{ borderRadius: 2 }} />
                <Skeleton variant="rounded" height={52} width={52} sx={{ borderRadius: 2 }} />
            </Box>

            <Skeleton variant="text" height={20} width={'60%'} sx={{ mt: 1 }} />

            <Typography sx={{ fontSize: 15, color: colors.grey[700], fontWeight: 400, mt: 2 }}>انتخاب سایز</Typography>

            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Skeleton variant="rounded" height={48} width={48} sx={{ borderRadius: 2 }} />
            </Box>
            <Skeleton variant="text" height={20} width={80} sx={{ mt: 1 }} />

            <Skeleton variant="rounded" height={38} width={136} sx={{ mt: 1 }} />

            <Divider sx={{ my: 3 }} />
            <Box sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: {
                    xs: 'row-reverse',
                    md: 'row'
                }
            }}>
                <Skeleton variant="rounded" height={56} width={112} />
                <Skeleton variant="text" height={24} width={130} sx={{}} />
            </Box>
            <Skeleton variant="rounded" height={48} width={'100%'} sx={{
                mt: 2, display: {
                    xs: 'none',
                    md: 'block'
                }
            }} />

        </Box>
    )
}